    // Preloader — homepage only, once per session
    (function() {
      var pl = document.getElementById('preloader');
      if (!pl) return;
      if (window.Shopify && window.Shopify.designMode) {
        pl.classList.add('loaded');
        return;
      }
      window.addEventListener('load', function() {
        setTimeout(function() {
          pl.classList.add('loaded');
          sessionStorage.setItem('ap_welcomed', '1');
        }, 1800);
      });
    })();

    // Header scroll behavior
    const header = document.getElementById('site-header');
    let lastScroll = 0;

    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
      if (currentScroll > 80) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
      lastScroll = currentScroll;
    });

    // ============================================
    // SCROLL LOCK — shared by nav overlay + cart drawer
    // Prevents the scroll-jump that plain overflow:hidden causes by
    // pinning the body in place at its current scroll offset and
    // restoring it on unlock. Reference-counted so nav + cart can
    // never fight over the locked scroll position.
    // ============================================
    const ScrollLock = {
      _scrollY: 0,
      _count: 0,

      lock() {
        if (this._count === 0) {
          this._scrollY = window.scrollY;
          document.body.style.top = `-${this._scrollY}px`;
          document.body.classList.add('scroll-locked');
        }
        this._count++;
      },

      unlock() {
        this._count = Math.max(0, this._count - 1);
        if (this._count === 0) {
          document.body.classList.remove('scroll-locked');
          document.body.style.top = '';
          window.scrollTo(0, this._scrollY || 0);
        }
      }
    };

    // ============================================
    // OVERLAY NAVIGATION
    // ============================================
    const navToggle = document.getElementById('nav-toggle');
    const overlayNav = document.getElementById('overlay-nav');
    const navImages = overlayNav.querySelectorAll('.overlay-nav__right-img');
    const defaultImg = overlayNav.querySelector('[data-default]');

    // Toggle menu open/close
    navToggle.addEventListener('click', () => {
      const isOpen = overlayNav.classList.toggle('active');
      navToggle.classList.toggle('active');
      document.body.classList.toggle('nav-open', isOpen);

      if (isOpen) {
        ScrollLock.lock();
      } else {
        ScrollLock.unlock();
        // Reset sub-menus and images when closing
        document.querySelectorAll('.overlay-nav__sub').forEach(s => s.classList.remove('expanded'));
        navImages.forEach(img => img.classList.remove('active'));
        if (defaultImg) defaultImg.classList.add('active');
      }
    });

    // Sub-menu toggles (any link with data-menu pointing to a sub)
    overlayNav.querySelectorAll('[data-menu]').forEach(link => {
      const subId = link.dataset.menu;
      const sub = document.getElementById(subId);
      if (!sub) return;
      link.addEventListener('click', (e) => {
        e.preventDefault();
        sub.classList.toggle('expanded');
      });
    });

    // Hover to change right-side image
    function showNavImage(src) {
      navImages.forEach(img => img.classList.remove('active'));
      const target = overlayNav.querySelector(`.overlay-nav__right-img[data-src="${src}"]`);
      if (target) target.classList.add('active');
      else if (defaultImg) defaultImg.classList.add('active');
    }

    function resetNavImage() {
      navImages.forEach(img => img.classList.remove('active'));
      if (defaultImg) defaultImg.classList.add('active');
    }

    // Attach hover listeners to all nav links with data-img
    overlayNav.querySelectorAll('[data-img]').forEach(link => {
      link.addEventListener('mouseenter', () => showNavImage(link.dataset.img));
      link.addEventListener('mouseleave', resetNavImage);
    });

    // Close menu on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        if (overlayNav.classList.contains('active')) {
          overlayNav.classList.remove('active');
          navToggle.classList.remove('active');
          document.body.classList.remove('nav-open');
          ScrollLock.unlock();
        }
        if (searchPanel && searchPanel.classList.contains('is-open')) {
          closeSearch();
        }
      }
    });

    // ============================================
    // SEARCH PANEL — Dropdown from header
    // ============================================
    const searchToggle = document.getElementById('search-toggle');
    const searchPanel = document.getElementById('search-panel');
    const searchInput = document.getElementById('search-panel-input');
    const searchClose = document.getElementById('search-close');
    const searchResults = document.getElementById('search-results');
    let searchDebounce = null;

    function openSearch() {
      searchPanel.classList.add('is-open');
      header.classList.add('search-active');
      setTimeout(() => searchInput.focus(), 100);
    }

    function closeSearch() {
      searchPanel.classList.remove('is-open');
      header.classList.remove('search-active');
      searchInput.value = '';
      while (searchResults.firstChild) searchResults.removeChild(searchResults.firstChild);
    }

    if (searchToggle) {
      searchToggle.addEventListener('click', (e) => {
        e.preventDefault();
        if (searchPanel.classList.contains('is-open')) {
          closeSearch();
        } else {
          openSearch();
        }
      });
    }

    if (searchClose) {
      searchClose.addEventListener('click', closeSearch);
    }

    // Close search when clicking outside
    document.addEventListener('click', (e) => {
      if (searchPanel && searchPanel.classList.contains('is-open')) {
        if (!searchPanel.contains(e.target) && e.target !== searchToggle && !searchToggle.contains(e.target)) {
          closeSearch();
        }
      }
    });

    // Build a search result element safely (no innerHTML with user data)
    function createResultEl(item) {
      const a = document.createElement('a');
      a.href = item.url;
      a.className = 'search-panel__result';

      if (item.image) {
        const imgWrap = document.createElement('div');
        imgWrap.className = 'search-panel__result-image';
        const img = document.createElement('img');
        img.src = item.image;
        img.alt = '';
        img.loading = 'lazy';
        imgWrap.appendChild(img);
        a.appendChild(imgWrap);
      }

      const info = document.createElement('div');
      const title = document.createElement('p');
      title.className = 'search-panel__result-title';
      title.textContent = item.title;
      const type = document.createElement('p');
      type.className = 'search-panel__result-type';
      type.textContent = item.type;
      info.appendChild(title);
      info.appendChild(type);
      a.appendChild(info);
      return a;
    }

    // Predictive search using Shopify API
    if (searchInput) {
      searchInput.addEventListener('input', () => {
        clearTimeout(searchDebounce);
        const query = searchInput.value.trim();

        if (query.length < 2) {
          while (searchResults.firstChild) searchResults.removeChild(searchResults.firstChild);
          const hint = document.createElement('p');
          hint.className = 'search-panel__hint';
          hint.textContent = 'Type to search';
          searchResults.appendChild(hint);
          return;
        }

        searchDebounce = setTimeout(() => {
          fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,page,collection&resources[limit]=6')
            .then(r => r.json())
            .then(data => {
              while (searchResults.firstChild) searchResults.removeChild(searchResults.firstChild);
              const items = [];
              const resources = data.resources && data.resources.results;
              if (!resources) {
                const empty = document.createElement('p');
                empty.className = 'search-panel__empty';
                empty.textContent = 'No results';
                searchResults.appendChild(empty);
                return;
              }

              ['products', 'pages', 'collections'].forEach(type => {
                if (resources[type]) {
                  resources[type].forEach(item => {
                    items.push({
                      title: item.title,
                      url: item.url,
                      type: type === 'products' ? 'Timepiece' : type === 'collections' ? 'Collection' : 'Page',
                      image: item.image || (item.featured_image && item.featured_image.url) || ''
                    });
                  });
                }
              });

              if (items.length === 0) {
                const empty = document.createElement('p');
                empty.className = 'search-panel__empty';
                empty.textContent = 'No results for \u201C' + query + '\u201D';
                searchResults.appendChild(empty);
                return;
              }

              items.forEach(item => {
                searchResults.appendChild(createResultEl(item));
              });
            })
            .catch(() => {
              while (searchResults.firstChild) searchResults.removeChild(searchResults.firstChild);
              const err = document.createElement('p');
              err.className = 'search-panel__empty';
              err.textContent = 'Search unavailable';
              searchResults.appendChild(err);
            });
        }, 250);
      });
    }

    // ============================================
    // SCROLL ANIMATIONS
    // ============================================
    // Scroll animations — disabled in Shopify editor
    if (window.Shopify && window.Shopify.designMode) {
      document.documentElement.classList.add('shopify-design-mode');
    } else {
      const fadeEls = document.querySelectorAll('.fade-up');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });

      fadeEls.forEach(el => observer.observe(el));
    }

    // Lazy-load video when near viewport
    const videoEl = document.querySelector('.hero-banner video');
    if (videoEl) {
      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            videoEl.setAttribute('preload', 'auto');
            videoEl.load();
            videoObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '200px' });
      videoObserver.observe(videoEl);
    }

    // ============================================
    // FLOATING ADVISOR — persistent WhatsApp/email channel
    // ============================================
    (function() {
      const widget = document.getElementById('floating-advisor');
      if (!widget) return;

      const toggle = document.getElementById('floating-advisor-toggle');

      window.addEventListener('scroll', () => {
        widget.classList.toggle('is-visible', window.scrollY > 400);
      }, { passive: true });

      toggle.addEventListener('click', () => {
        const isOpen = widget.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen);
      });

      document.addEventListener('click', (e) => {
        if (widget.classList.contains('is-open') && !widget.contains(e.target)) {
          widget.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && widget.classList.contains('is-open')) {
          widget.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    })();

    // ============================================
    // CART SYSTEM
    // ============================================
    const CartSystem = {
      drawer: null,
      overlay: null,
      itemsContainer: null,
      emptyState: null,
      footer: null,
      countBadge: null,
      subtotalEl: null,

      init() {
        this.drawer = document.getElementById('cart-drawer');
        this.overlay = document.getElementById('cart-drawer-overlay');
        this.itemsContainer = document.getElementById('cart-drawer-items');
        this.emptyState = document.getElementById('cart-drawer-empty');
        this.footer = document.getElementById('cart-drawer-footer');
        this.countBadge = document.getElementById('cart-count');
        this.subtotalEl = document.getElementById('cart-drawer-subtotal');

        if (!this.drawer) return;

        const toggle = document.getElementById('cart-toggle');
        const close = document.getElementById('cart-drawer-close');

        if (toggle) toggle.addEventListener('click', () => this.open());
        if (close) close.addEventListener('click', () => this.close());
        if (this.overlay) this.overlay.addEventListener('click', () => this.close());

        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.drawer.classList.contains('is-open')) {
            this.close();
          }
        });

        this.refresh();
      },

      open() {
        ScrollLock.lock();
        this.drawer.classList.add('is-open');
        document.body.classList.add('cart-open');
        // Reset drawer body scroll to top
        const body = document.getElementById('cart-drawer-body');
        if (body) body.scrollTop = 0;
      },

      close() {
        this.drawer.classList.remove('is-open');
        document.body.classList.remove('cart-open');
        ScrollLock.unlock();
      },

      async refresh() {
        try {
          const res = await fetch('/cart.js', { credentials: 'same-origin' });
          const cart = await res.json();
          this.render(cart);
        } catch (e) { /* silent */ }
      },

      render(cart) {
        /* Every element here is optional: with the theme's Enquiry only
           setting on, the header renders no cart control and no drawer at
           all, so this object must never assume a node it did not find. */
        if (this.countBadge) {
          if (cart.item_count > 0) {
            this.countBadge.textContent = cart.item_count;
            this.countBadge.style.display = '';
          } else {
            this.countBadge.style.display = 'none';
          }
        }

        if (!this.itemsContainer) return;

        if (cart.item_count === 0) {
          if (this.emptyState) this.emptyState.style.display = '';
          this.itemsContainer.style.display = 'none';
          if (this.footer) this.footer.style.display = 'none';
        } else {
          if (this.emptyState) this.emptyState.style.display = 'none';
          this.itemsContainer.style.display = '';
          if (this.footer) this.footer.style.display = '';
        }

        while (this.itemsContainer.firstChild) {
          this.itemsContainer.removeChild(this.itemsContainer.firstChild);
        }

        cart.items.forEach(item => {
          this.itemsContainer.appendChild(this.createItemEl(item));
        });

        if (this.subtotalEl) this.subtotalEl.textContent = this.formatMoney(cart.total_price);
      },

      createItemEl(item) {
        const el = document.createElement('div');
        el.className = 'cart-drawer__item';
        el.dataset.key = item.key;

        const imgWrap = document.createElement('div');
        imgWrap.className = 'cart-drawer__item-image';
        if (item.image) {
          const img = document.createElement('img');
          img.src = this.resizeImage(item.image, '160x');
          img.alt = item.title;
          img.loading = 'lazy';
          imgWrap.appendChild(img);
        }
        el.appendChild(imgWrap);

        const details = document.createElement('div');
        details.className = 'cart-drawer__item-details';

        const title = document.createElement('p');
        title.className = 'cart-drawer__item-title';
        title.textContent = item.product_title;
        details.appendChild(title);

        if (item.variant_title) {
          const variant = document.createElement('p');
          variant.className = 'cart-drawer__item-variant';
          variant.textContent = item.variant_title;
          details.appendChild(variant);
        }

        const price = document.createElement('p');
        price.className = 'cart-drawer__item-price';
        price.textContent = this.formatMoney(item.final_line_price);
        details.appendChild(price);

        const actions = document.createElement('div');
        actions.className = 'cart-drawer__item-actions';

        const qtyWrap = document.createElement('div');
        qtyWrap.className = 'cart-drawer__item-qty';

        const minus = document.createElement('button');
        minus.type = 'button';
        minus.textContent = '\u2212';
        minus.setAttribute('aria-label', 'Decrease');
        minus.addEventListener('click', () => this.updateItem(item.key, item.quantity - 1));
        qtyWrap.appendChild(minus);

        const qtyNum = document.createElement('span');
        qtyNum.textContent = item.quantity;
        qtyWrap.appendChild(qtyNum);

        const plus = document.createElement('button');
        plus.type = 'button';
        plus.textContent = '+';
        plus.setAttribute('aria-label', 'Increase');
        plus.addEventListener('click', () => this.updateItem(item.key, item.quantity + 1));
        qtyWrap.appendChild(plus);

        actions.appendChild(qtyWrap);

        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'cart-drawer__item-remove';
        remove.textContent = 'Remove';
        remove.addEventListener('click', () => {
          el.classList.add('is-removing');
          setTimeout(() => this.updateItem(item.key, 0), 300);
        });
        actions.appendChild(remove);

        details.appendChild(actions);
        el.appendChild(details);

        return el;
      },

      _updating: false,

      async addItem(variantId, quantity) {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: quantity })
        });
        if (!res.ok) throw new Error('Add failed');
        await this.refresh();
        this.open();
      },

      async updateItem(key, quantity) {
        if (this._updating) return;
        this._updating = true;
        try {
          const res = await fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: quantity })
          });
          if (!res.ok) throw new Error('Update failed');
          const cart = await res.json();
          this.render(cart);
        } catch (e) { /* silent */ }
        this._updating = false;
      },

      formatMoney(cents) {
        const format = (window.AP && window.AP.moneyFormat) || '${{amount}}';
        const amount = (cents / 100).toFixed(2);
        const amountNoDecimals = Math.round(cents / 100).toString();
        const amountWithCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        const amountNoDecimalsWithCommas = amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        const amountCommaSep = amount.replace(/\B(?=(\d{3})+(?!\d))/g, '.').replace('.', ',').replace(/,(\d{2})$/, ',$1');
        const parts = amount.split('.');
        const amountWithCommaSeparator = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
        return format
          .replace('{{amount_with_comma_separator}}', amountWithCommaSeparator)
          .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
          .replace('{{amount_no_decimals}}', amountNoDecimalsWithCommas)
          .replace('{{amount}}', amountWithCommas);
      },

      resizeImage(url, size) {
        if (!url) return '';
        return url.replace(/(\.[^.]+)$/, '_' + size + '$1');
      }
    };

    // ============================================
    // PRODUCT PAGE — Variant Selection + ATC
    // ============================================
    const ProductPage = {
      variants: [],
      selectedOptions: {},
      atcButton: null,
      priceEl: null,
      enquireLink: null,

      /* The variant picker and the Add to Selection button used to arrive and
         leave together, so one guard covered both. With the theme's Enquiry
         only setting on the button is gone and the picker stays — it is how a
         client chooses the metal before writing to the house — so the guard is
         on the variant JSON alone and every use of the button is checked. */
      init() {
        const jsonEl = document.getElementById('pdp-variant-json');
        this.atcButton = document.getElementById('add-to-cart');
        this.priceEl = document.getElementById('pdp-price');
        this.enquireLink = document.getElementById('pdp-enquire');

        if (!jsonEl) return;

        try {
          this.variants = JSON.parse(jsonEl.textContent);
        } catch (e) { return; }

        document.querySelectorAll('.pdp-variant__btn.is-active').forEach(btn => {
          this.selectedOptions[btn.dataset.optionPosition] = btn.dataset.value;
        });

        document.querySelectorAll('.pdp-variant__btn').forEach(btn => {
          btn.addEventListener('click', () => {
            const siblings = btn.closest('.pdp-variant__options').querySelectorAll('.pdp-variant__btn');
            siblings.forEach(s => s.classList.remove('is-active'));
            btn.classList.add('is-active');
            this.selectedOptions[btn.dataset.optionPosition] = btn.dataset.value;
            this.updateVariant();
          });
        });

        const qtyInput = document.getElementById('qty-input');
        const qtyMinus = document.getElementById('qty-minus');
        const qtyPlus = document.getElementById('qty-plus');

        if (qtyMinus && qtyPlus && qtyInput) {
          qtyMinus.addEventListener('click', () => {
            const val = parseInt(qtyInput.value, 10);
            if (val > 1) qtyInput.value = val - 1;
          });
          qtyPlus.addEventListener('click', () => {
            const val = parseInt(qtyInput.value, 10);
            if (val < 10) qtyInput.value = val + 1;
          });
        }

        if (!this.atcButton) return;

        this.atcButton.addEventListener('click', () => {
          if (this.atcButton.disabled) return;
          const variantId = parseInt(this.atcButton.dataset.variantId, 10);
          const qtyEl = document.getElementById('qty-input');
          const qty = (qtyEl && parseInt(qtyEl.value, 10)) || 1;

          const textEl = document.getElementById('atc-text');
          const originalText = textEl.textContent;
          textEl.textContent = 'Adding\u2026';
          this.atcButton.disabled = true;

          CartSystem.addItem(variantId, qty).then(() => {
            textEl.textContent = 'Added';
            this.atcButton.classList.add('is-added');
            setTimeout(() => {
              textEl.textContent = originalText;
              this.atcButton.classList.remove('is-added');
              this.atcButton.disabled = false;
            }, 2000);
          }).catch(() => {
            textEl.textContent = originalText;
            this.atcButton.disabled = false;
          });
        });
      },

      updateVariant() {
        const optionValues = [];
        for (let i = 1; i <= 3; i++) {
          if (this.selectedOptions[String(i)]) {
            optionValues.push(this.selectedOptions[String(i)]);
          }
        }

        const match = this.variants.find(v => {
          return optionValues.every((val, idx) => v.options[idx] === val);
        });

        if (match) {
          if (this.atcButton) {
            const atcText = document.getElementById('atc-text');
            this.atcButton.dataset.variantId = match.id;
            if (match.available) {
              this.atcButton.disabled = false;
              if (atcText) atcText.textContent = 'Add to Selection';
            } else {
              this.atcButton.disabled = true;
              if (atcText) atcText.textContent = 'Unavailable';
            }
          }
          /* Enquiry only: the boxed CTA carries ?ref=<sku>, so it has to follow
             the chosen variant the way the price does. Base href comes from the
             markup, so a store that repoints the route keeps working. */
          if (this.enquireLink) {
            const base = this.enquireLink.dataset.enquireBase || '';
            const sku = match.sku || '';
            this.enquireLink.href = sku
              ? base + (base.indexOf('?') === -1 ? '?' : '&') + 'ref=' + encodeURIComponent(sku)
              : base;
          }
          if (this.priceEl && match.price > 0) {
            this.priceEl.textContent = CartSystem.formatMoney(match.price);
          }
          const url = new URL(window.location);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url);
        }
      }
    };

    CartSystem.init();
    ProductPage.init();

    /* Details accordion toggle */
    document.querySelectorAll('.pdp-details__toggle').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var details = btn.closest('.pdp-details');
        var body = details.querySelector('.pdp-details__body');
        var isOpen = details.classList.contains('is-open');

        if (isOpen) {
          /* Close: set explicit height first so transition has a start value */
          body.style.maxHeight = body.scrollHeight + 'px';
          requestAnimationFrame(function() {
            body.style.maxHeight = '0';
          });
          details.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
        } else {
          /* Open: transition to actual content height */
          details.classList.add('is-open');
          body.style.maxHeight = body.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
          /* After transition, remove inline style so content can reflow */
          body.addEventListener('transitionend', function handler() {
            if (details.classList.contains('is-open')) {
              body.style.maxHeight = 'none';
            }
            body.removeEventListener('transitionend', handler);
          });
        }
      });
    });
